import {isEmpty} from 'lodash-es';
import type {ReactElement} from 'react';
import {useState} from 'react';

import {Button} from '@/components';
import type {BusinessFee} from '@/types';

import FeeFormModal from './FeeFormModal';

type FeeUpdateButtonProps = {
  initialData?: BusinessFee;
  businessId?: string;
  businessName?: string;
  /** Test hook prefix; the open button renders it as `<dataCy>-button`. */
  dataCy?: string;
  /** Test hook prefix for the form modal (each field namespaces under it). */
  formDataCy?: string;
  /** Called after a successful create/update so the list can refresh in place. */
  onSuccess?: () => void | Promise<void>;
};

const FeeUpdateButton = ({
  initialData,
  businessId,
  businessName,
  dataCy,
  formDataCy,
  onSuccess,
}: FeeUpdateButtonProps): ReactElement => {
  const [showFullScreen, setShowFullScreen] = useState(false);
  const updateLabel = isEmpty(initialData) ? 'Create Fee +' : 'Update Fee';
  const toggleFullScreen = () => {
    setShowFullScreen(!showFullScreen);
  };

  return showFullScreen ? (
    <FeeFormModal
      isOpen={showFullScreen}
      onClose={toggleFullScreen}
      initialData={initialData}
      businessId={businessId}
      businessName={businessName}
      formDataCy={formDataCy}
      onSuccess={onSuccess}
    />
  ) : (
    <Button
      dataCy={dataCy}
      variant="solid"
      colorScheme="cyan"
      onClick={toggleFullScreen}
    >
      {updateLabel}
    </Button>
  );
};

export default FeeUpdateButton;
